import * as React from 'react';

import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';

import InsightsReportsQueriesModalStepDetails from './steps/details/InsightsReportsQueriesModalStepDetails';
import InsightsReportsQueriesModalStepChannels from './steps/channels/InsightsReportsQueriesModalStepChannels';

import { __t, applyTranslations } from 'utils/language';
import {
  STEP_CHANNELS,
  STEP_DETAILS,
  TITLE
} from 'modules/insights/reports/utils/queries/insights-reports-queries';

import type {
  QueryChannel,
  QueryFieldType,
  QueryKeyword,
  QueryModalErrors,
  QueryModalTextFields,
  QueryStep
} from 'modules/insights/reports/types';

applyTranslations(require('modules/insights/reports/components/queries/modals/insights-reports-queries-modal.i18n.json'));

const MODAL_MSG_KEY = 'insights_reports_queries_modal';

type Props = {
  stepIndex: number,
  stepCount: number,
  stepInfo: QueryStep,
  textFields: QueryModalTextFields,
  errors: QueryModalErrors,
  isShowingKpis: boolean,
  onRenderActionButton: () => React.ReactNode,
  onRenderBackButton: () => React.ReactNode,
  onRenderCancelButton: () => React.ReactNode,
  onTextFieldChange: (fieldType: QueryFieldType, value: string) => void,
  onHashtagsFieldChange: (value: Array<QueryKeyword>) => void,
  onChannelsFieldChange: (channels: Array<QueryChannel>) => void,
  onShowKpisToggle: () => void
};

class InsightsReportsQueriesModalCollabaryInstagram extends React.PureComponent<Props> {
  renderStepDetails = (): JSX.Element => {
    const {
      textFields,
      errors,
      isShowingKpis,
      onTextFieldChange,
      onHashtagsFieldChange,
      onShowKpisToggle
    } = this.props;

    return (
      <div className="insights-reports-queries-modal-collabary-instagram__details">
        <InsightsReportsQueriesModalStepDetails
          textFields={textFields}
          errors={errors}
          isShowingKpis={isShowingKpis}
          onTextFieldChange={onTextFieldChange}
          onHashtagsFieldChange={onHashtagsFieldChange}
          onShowKpisToggle={onShowKpisToggle}
        />
      </div>
    );
  };

  renderStepChannels = (): JSX.Element => {
    const {
      textFields,
      errors,
      onChannelsFieldChange
    } = this.props;

    return (
      <div className="insights-reports-queries-modal-collabary-instagram__channels">
        <InsightsReportsQueriesModalStepChannels
          textFields={textFields}
          errors={errors}
          onChannelsFieldChange={onChannelsFieldChange}
        />
      </div>
    );
  };

  renderFooter(): React.ReactNode {
    const { onRenderActionButton, onRenderBackButton, onRenderCancelButton } = this.props;

    return (
      <ModalFrameFooter
        className="insights-reports-queries-modal-collabary-instagram__footer"
      >
        {onRenderCancelButton()}
        {onRenderBackButton()}
        {onRenderActionButton()}
      </ModalFrameFooter>
    );
  }

  renderBody(): React.ReactNode {
    const { stepInfo } = this.props;

    const steps = {
      [STEP_DETAILS]: this.renderStepDetails,
      [STEP_CHANNELS]: this.renderStepChannels
    };

    return (
      <ModalFrameInner
        minHeight={376}
      >
        {steps[stepInfo.key]()}
      </ModalFrameInner>
    );
  }

  render(): React.ReactNode {
    const { stepIndex, stepCount } = this.props;

    return (
      <ModalFrame
        title={__t(`${MODAL_MSG_KEY}.${TITLE}`)}
        classNameFrame="insights-reports-queries-modal-collabary-instagram"
        stepCounter={{
          index: stepIndex + 1,
          count: stepCount
        }}
      >
        {this.renderBody()}
        {this.renderFooter()}
      </ModalFrame>
    );
  }
}

export default InsightsReportsQueriesModalCollabaryInstagram;
